
export default ($axios) => ({
	getCountries(params={}) {
		return $axios.get(`/countries`, { params } )
	},
	getStates(params={}) {
		return $axios.get(`/states`, { params } )
	}
})